import {
  React,
  Component,
  Redirect,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {Waiting} from 'imports/DesignImports';

import {CircularProgress} from 'material-ui';

class ProfileView extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: props.cookies.get('user'),
      currentStage: {},
      error: false,
      loading: true,
      token: props.cookies.get('token'),
    }
  }

  componentDidMount() {
    this.getCurrentStage();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar el portafolio. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return( this.getComponent(this.state.currentStage.stage.name) );
  }

  getComponent = (stageName) => {
    switch(stageName) {
      case 'SP': return(
        <Redirect to='/portfolio/setup'/>
      );
      case 'PO': return(
        <Redirect to='/portfolio/postulation/projects'/>
      );
      case 'SI': return(
        <Redirect to='/portfolio/selection'/>
      );
      case 'SE': return(
        <Redirect to='/portfolio/economic_selection'/>
      );
      case 'WS': return(
        <Redirect to='/portfolio/workshop'/>
      );
      case 'FI': return(
        <Redirect to='/portfolio/files'/>
      );
      case 'PT': return(
        <h1>Proceso terminado</h1>
      );
      default: return (
        <Waiting title={"El proceso no ha comenzado"} message={"La empresa todavía no comienza con el proceso de i3"} />
      );
    }
  }

  getCurrentStage = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.getCurrentStage(this.state.user.company_id))
    .then((response) => {
      this.props.cookies.set('current_stage', JSON.stringify(response.data[response.data.length - 1]), { path: '/' });
      this.setState({
        loading: false,
        error: false,
        currentStage: response.data[response.data.length - 1]
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loading:false,
        error: true,
      });
    });
  }
}

export default withRouter(withCookies(ProfileView));



// WEBPACK FOOTER //
// ./src/views/common/PortfolioView.js